export default "__VITE_ASSET__BfReB59C__"